import angular from 'angular';
import templateUrl from './AppEntry.ng.html';
import '../_directives/appSignup/appSignup.js';
   
var app = angular.module("signup.app", ['app-signup','ui.select', 'ngSanitize']); 
 
app.directive('appEntry', function() {
    return {
        restrict: 'E',
        templateUrl: templateUrl,
        controller: ["$scope", "$q", function($scope, $q){
        }]
    }
});



/** WEBPACK FOOTER **
 ** ./signup/AppEntry.js
 **/